<template>
    <div class="md:grid md:grid-cols-12 md:gap-6">
        <div class="sm:col-span-6">
            <div class="mt-1">
                <FormLabel :value="$t('messages.experience_amount')" for="experience_amount" />
                <FormInput
                    id="experience_amount"
                    v-model.number="form.experience_amount"
                    min="1"
                    name="experience_amount"
                    type="number"
                    class="mt-1"
                />
                <FormError :value="errors['options.experience_amount']" class="mt-2" />
            </div>
        </div>

        <div class="sm:col-span-6">
            <div class="mt-1">
                <FormLabel :value="$t('messages.health_amount')" for="health_amount" />
                <FormInput
                    id="health_amount"
                    v-model.number="form.health_amount"
                    name="health_amount"
                    type="number"
                    class="mt-1"
                />
                <FormError :value="errors['options.health_amount']" class="mt-2" />
            </div>
        </div>

        <div class="sm:col-span-6">
            <div class="mt-1">
                <FormLabel :value="$t('messages.coins_amount')" for="coins_amount" />
                <FormInput
                    id="coins_amount"
                    v-model.number="form.coins_amount"
                    name="coins_amount"
                    type="number"
                    class="mt-1"
                />
                <FormError :value="errors['options.coins_amount']" class="mt-2" />
            </div>
        </div>

        <div class="sm:col-span-6">
            <div class="mt-1">
                <FormLabel :value="$t('messages.energy_amount')" for="energy_amount" />
                <FormInput
                    id="energy_amount"
                    v-model.number="form.energy_amount"
                    name="energy_amount"
                    type="number"
                    class="mt-1"
                />
                <FormError :value="errors['options.energy_amount']" class="mt-2" />
            </div>
        </div>
    </div>
</template>

<script>
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import FormError from '@/components/Forms/FormError.vue';

export default {
    name: 'ItemModifyCurrencyOptions',
    components: {
        FormLabel,
        FormInput,
        FormError,
    },
    props: {
        modelValue: {
            required: true,
        },
        errors: {
            required: true,
        },
    },
    emits: ['update:modelValue'],
    data() {
        return {
            form: this.modelValue,
        };
    },
    watch: {
        form(newVal) {
            this.$emit('update:modelValue', newVal);
        },
    },
};
</script>
